<template>
  <validated-form
    :disabled="isAdding"
    name="addGiftCard"
    @valid-submit="submit"
  >
    <div class="layout layout--split">
      <div class="layout__block layout__block--card-number">
        <text-input
          v-model="cardNumber"
          type="text"
          :label="addGiftCardContent.cardNumberInputPlaceholder"
          name="cardNumber"
          inputmode="numeric"
          mask="giftCard"
          :validations="{
            required: true
          }"
        />
      </div>

      <div
        v-if="paymentGateway.methods.giftCard.giftCardPinRequired"
        class="layout__block layout__block--card-pin"
      >
        <text-input
          v-model="pin"
          type="text"
          :label="addGiftCardContent.pinInputPlaceholder"
          name="pin"
          allowed-characters="0-9a-zA-Z"
          inputmode="numeric"
          :validations="{
            required: true
          }"
        />
      </div>
    </div>

    <div class="right">
      <button
        class="button button--primary button--auto-width"
        :class="{
          'button--loading': isAdding
        }"
        type="submit"
      >
        {{ addGiftCardContent.cta }}
      </button>
    </div>
  </validated-form>
</template>


<script>
  import errorHandlers from '@/services/error-handlers';
  import events from '@/services/events';
  import { mapGetters } from 'vuex';

  export default {
    name: 'AddGiftCard',

    props: {
      paymentGateway: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        cardNumber: null,
        isAdding: false,
        pin: null
      };
    },

    computed: {
      ...mapGetters('giftCards', ['giftCards']),
      ...mapGetters('locations', ['selectedLocation']),
      ...mapGetters('content', ['content']),

      addGiftCardContent() {
        const content = this.content.AddGiftCardAtCheckout;

        return {
          cta: content.metadata.applyCardCta,
          cardNumberInputPlaceholder: content.metadata.cardNumberInputPlaceholder,
          pinInputPlaceholder: content.metadata.pinInputPlaceholder
        };
      }
    },

    methods: {
      handleSubmitError(error) {
        if (error.message === 'card already added') {
          events.emit('notification', {
            type: 'error',
            message: 'Your gift card has already been applied.',
            clickToDismiss: true
          });
        }

        else if (error.message === 'no balance remaining') {
          events.emit('notification', {
            type: 'error',
            message: 'Your gift card has no remaining balance.',
            clickToDismiss: true
          });
        }

        else {
          errorHandlers.generic(error);
        }
      },

      async submit() {
        try {
          this.isAdding = true;

          await this.$store.dispatch('giftCards/addCard', {
            cardNumber: this.cardNumber,
            pin: this.pin,
            storeId: this.selectedLocation.storeId
          });

          events.emit('notification', {
            type: 'success',
            message: 'Gift card balance applied.'
          });

          // this.$triggerGoogleTrackingEvent('AddNewGiftCard', 'GiftCards');

          this.$triggerNewRelicEvent('AddNewGiftCard', 'Information', 'Added New Gift Card');

          this.$closeModal('addGiftCard');
        }

        catch (error) {
          this.handleSubmitError(error);
        }

        finally {
          this.isAdding = false;
        }
      }
    }
  };
</script>
